import { Form, Col, Input, Select, notification, Upload, Button, message, Tooltip, InputNumber, Tabs, Row, Checkbox } from "antd";
import { useEffect, useState } from "react";
import { FormGW, FormularioDinamico, SelectPaginacao } from "../../components";
import api from "../../services/api";
import axios from "axios";
import { manutencaoActions } from "../../actions";


export default function ManutencaoPlanoContaContabil({ formulario, carregando, aoSalvar, editando, atualizarLista }) {

    const [abaSelecionada, setAbaSelecionada] = useState("1");
    const [contas, setContas] = useState([]);
    const [loadingContas, setLoadingContas] = useState([]);

    const salvarManutencao = (values) => {
        carregando(true);
        const isEdicao = !!values.pcc_id;
        const endpoint = values.pcc_id ? 'PlanoContaContabil/Editar' : 'PlanoContaContabil/Incluir';
        const metodo = isEdicao ? api.put : api.post;


        metodo(endpoint, values)
            .then((res) => {
                if (res.status === 200) {
                    notification.success({
                        message: "Operação concluída",
                        description: "Plano de contas salvo com sucesso!",
                    });
                    aoSalvar(res.data);
                    atualizarLista();
                    formulario.resetFields();
                }
            })
            .catch((err) => {
                console.error(err);
                notification.error({
                    message: "Erro ao salvar",
                    description: "Houve um problema ao salvar os dados. Tente novamente.",
                });
            })
            .finally(() => {
                carregando(false);
            });


    }

    const handleFocusCombo = async () => {
        try {
            const res = await api.get("PlanoContaContabil/ListarTodos");
            setContas(res.data);
        } catch (error) {
            console.error("Erro ao buscar contas:", error);
        }
    };

    return (
        <Tabs type="card" centered activeKey={abaSelecionada} onChange={(tab) => setAbaSelecionada(tab)}>
            <Tabs.TabPane tab={"Plano de Contas"} key={"1"}>
                <Form layout="vertical" form={formulario} name="ManutencaoPlanoContaContabil" onFinish={salvarManutencao}>
                    <Row gutter={[8, 0]}>
                        <Form.Item name="pcc_id" hidden />
                        <Col xs={10} sm={10} md={5} lg={10} xl={6}>
                            <Form.Item label="Código Estruturado" name="pcc_codigoestruturado">
                                <Input placeholder="Código estruturado" />
                            </Form.Item>
                        </Col>
                        <Col xs={10} sm={10} md={10} lg={10} xl={6}>
                            <Form.Item label="Código Reduzido:" name="pcc_codigoreduzido" rules={[{ required: true, message: 'Informe o Código Reduzido da Conta' }]}>
                                <Input placeholder="Código Reduzido" />
                            </Form.Item>
                        </Col>
                        <Col xs={10} sm={10} md={10} lg={10} xl={12}>
                            <Form.Item label="Metodo Analítico Sintético" name="pcc_analiticosintetico" rules={[{ required: true, message: 'Informe o Método Analítico Sintético da Conta' }]}>
                                <Select placeholder="Método">
                                    <Select.Option value={0}>Analítico</Select.Option>
                                    <Select.Option value={1}>Sintético</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col xs={10} sm={10} md={10} lg={10} xl={6}>
                            <Form.Item label="Nível:" name="pcc_grau" rules={[{ required: true, message: 'Informe o Grau da Conta' }]}>
                                <Input placeholder="Nível" />
                            </Form.Item>
                        </Col>
                        <Col xs={10} sm={10} md={10} lg={10} xl={12}>
                            <Form.Item label="Descrição Conta" name="pcc_descricao" rules={[{ required: true, message: 'Informe a natureza da Conta' }]}>
                                <Input placeholder="Descrição Conta" />
                            </Form.Item>
                        </Col>
                        <Col xs={10} sm={10} md={10} lg={10} xl={6}>
                            <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.pcc_grau !== currentValues.pcc_grau}>
                                {({ getFieldValue }) => {
                                    const nivel = parseInt(getFieldValue("pcc_grau"), 10);

                                    if (nivel <= 1 && getFieldValue("pcc_pai")) {
                                        setTimeout(() => {
                                            formulario.setFieldsValue({ pcc_pai: null });
                                        }, 0);
                                    }
                                    return (
                                        <Form.Item label="Conta Pai" name="pcc_pai" rules={
                                            nivel > 1
                                                ? [{ required: true, message: 'Informe a Conta Pai para níveis acima de 1' }]
                                                : []
                                        }>
                                            <Select allowClear placeholder="Selecione a conta pai" showSearch optionFilterProp="children" onFocus={handleFocusCombo} filterOption={(input, option) =>
                                                (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                                            }>
                                                {contas.map((conta) => (
                                                    <Select.Option key={conta.pcc_id} value={conta.pcc_id}>{conta.pcc_descricao}</Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    )
                                }}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Outros Dados" key="2">
                <Form>
                    <Row gutter={[8, 0]}>
                        <Col>
                            <Form.Item>

                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Tabs.TabPane>
            <Tabs.TabPane tab="Importação" key="3">

            </Tabs.TabPane>
        </Tabs >
    )
}